import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { extendCommonButtonsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../contexts/stylesheet.js";
import { AsciiSpinner } from "../asciiSpinner.js";
const Button = ({ type, children, busyOnClick = true, forceShow, onClick, framed, sticky, className, ...rest })=>{
    const { buttons: { [type]: Button }, framed: framedClass, stickyButton: stickyClass, forceShowButton: forceShowButtonClassName } = useStylesheet().extend(...extendCommonButtonsStylesheet);
    const [isBusy, setIsBusy] = useState(false);
    const handleOnClick = useCallback((e)=>{
        if (!isBusy) {
            e.preventDefault();
            busyOnClick && setIsBusy(true);
            onClick?.(e);
        }
    }, [
        onClick,
        isBusy,
        busyOnClick
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        onClick: handleOnClick,
        onKeyDown: (e)=>{
            if (e.code.toLowerCase() === "space") {
                e.target.click();
            }
        },
        className: [
            framed ? framedClass : undefined,
            sticky ? stickyClass : undefined,
            forceShow ? forceShowButtonClassName : undefined,
            className
        ].filter(Boolean).join(" "),
        role: "button",
        ...rest,
        children: /*#__PURE__*/ _jsx("span", {
            children: isBusy ? /*#__PURE__*/ _jsx(AsciiSpinner, {}) : children
        })
    });
};
export { Button };
